import Index from './Index'
import Show from './Show'
import Seeder from './Seeder'
import Create from './Create'

export default [
  {
    props: true,
    path: 'centrocusto',
    name: 'centrocusto.index',
    component: Index,
    meta: {requiresAuth: true, label: 'Centro de Custo - Lista'}
  },
  {
    props: true,
    path: 'centrocusto/create',
    name: 'centrocusto.create',
    component: Create,
    meta: {requiresAuth: true, label: 'Centro de Custo - Novo'}
  },
  {
    props: true,
    path: 'centrocusto/:centrocusto',
    name: 'centrocusto.show',
    component: Show,
    meta: {requiresAuth: true, label: 'Centro de Custo - Visualizar'}
  },
  {
    props: true,
    path: 'centrocusto/:centrocusto/seeder',
    name: 'centrocusto.seeder',
    component: Seeder,
    meta: {requiresAuth: true, label: 'Centro de Custo - Seeder'}
  }
]



// WEBPACK FOOTER //
// ./src/features/Centro/routes.js